module.exports = __webpack_public_path__ + "img/borderEtPolygonWhite.26193c25.svg";